<template>
  <svg
    v-if="icon === 'sparkle'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
  >
    <path
      stroke-linecap="butt"
      stroke-linejoin="miter"
      fill-opacity="0"
      stroke-miterlimit="4"
      :stroke="color ?? '#000'"
      stroke-opacity="1"
      stroke-width="1.5"
      d=" M16,6.175999641418457 C16,11.600999832153320 20.39900016784668,15.998999999525025 25.824999809265137,15.998999999525025 C20.39900016784668,15.998999999525025 16,20.397999763488770 16,25.824000358581543 C16,20.397999763488770 11.600999832153320,15.998999999525025 6.175000190734863,15.998999999525025 C11.600999832153320,15.998999999525025 16,11.600999832153320 16,6.175999641418457z"
    />
  </svg>
  <svg
    v-else-if="icon === 'new-tab'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
  >
    <path
      :fill="color ?? '#000'"
      fill-opacity=".8"
      d="M9.146 2.146A.5.5 0 0 0 9.5 3h2.793L6.146 9.146a.5.5 0 1 0 .708.708L13 3.707V6.5a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.354.146Z"
    />
    <path
      :fill="color ?? '#000'"
      fill-opacity=".8"
      d="M2.44 4.44A1.5 1.5 0 0 0 2 5.5v7A1.5 1.5 0 0 0 3.5 14h7a1.5 1.5 0 0 0 1.5-1.5v-5a.5.5 0 0 0-1 0v5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h5a.5.5 0 1 0 0-1h-5a1.5 1.5 0 0 0-1.06.44Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'site-icon'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
  >
    <path
      :fill="color ?? '#000'"
      fill-opacity=".8"
      fill-rule="evenodd"
      d="M13.5 2h-11C1.67 2 1 2.67 1 3.5v9c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5ZM2 3.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5V5H2V3.5ZM2 6v6.5c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5V6H2Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'caret-down'"
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="5"
    fill="none"
  >
    <path
      :fill="color ?? '#000'"
      fill-opacity=".8"
      d="m3.646 4.354-3-3 .708-.708L4 3.293 6.646.646l.708.708-3 3L4 4.707l-.354-.353Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'magnifier'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
  >
    <path
      :fill="color ?? '#D9D9D9'"
      fill-rule="evenodd"
      d="M20 15a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm-1.126 4.581a6 6 0 1 1 .707-.707l4.273 4.272-.708.708-4.272-4.273Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'search-times'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
  >
    <path
      :fill="color ?? '#D9D9D9'"
      fill-rule="evenodd"
      d="M16 24a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.293-12.707L16 14.586l-3.293-3.293-1.414 1.414L14.586 16l-3.293 3.293 1.414 1.414L16 17.414l3.293 3.293 1.414-1.414L17.414 16l3.293-3.293-1.414-1.414Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'checkmark'"
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    fill="none"
  >
    <path :stroke="color ?? '#fff'" stroke-width="1.5" d="M9.47 3.5 5.1 7.89 2.7 5.5" />
  </svg>
  <svg
    v-else-if="icon === 'hyphen'"
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    fill="none"
  >
    <path :stroke="color ?? '#fff'" stroke-width="1.5" d="M2 6h8" />
  </svg>
  <svg
    v-else-if="icon === 'forward-arrow'"
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="9"
    fill="none"
    viewBox="0 0 9 9"
  >
    <path
      fill="#000"
      fill-opacity=".8"
      d="m4.994 8.145-.703-.696 2.442-2.441H.6V3.992h6.133L4.29 1.555l.703-.7L8.64 4.5 4.994 8.145Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'back-arrow'"
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="9"
    fill="none"
  >
    <path
      :fill="color ?? '#000'"
      fill-opacity=".8"
      d="M3.875 8.29.085 4.5 3.876.71l.805.798-2.41 2.41h5.855v1.164H2.27l2.41 2.406-.805.801Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'webflow-logo'"
    xmlns="http://www.w3.org/2000/svg"
    width="138"
    height="23"
    fill="none"
  >
    <path
      fill="#146EF5"
      fill-rule="evenodd"
      d="M36.87 0 25.11 23H14.06l4.92-9.53h-.22C14.7 18.74 8.64 22.2 0 23v-9.4s5.52-.33 8.77-3.74H0V0h9.86v8.1h.22L14.11 0h7.45v8.06h.23L25.97 0h10.9Z"
      clip-rule="evenodd"
    />
    <path fill="#080808" d="M101.03 20.46h3.17V2.24h-3.17v18.22Z" />
    <path
      fill="#080808"
      fill-rule="evenodd"
      d="M83.53 20.28a5.9 5.9 0 0 0 5.27-.43 5.82 5.82 0 0 0 2.16-2.38c.5-1.01.76-2.16.76-3.45s-.26-2.44-.79-3.46a5.78 5.78 0 0 0-2.2-2.36 6 6 0 0 0-5.38-.4 4.63 4.63 0 0 0-1.85 1.4V2.25h-3.19v18.21h3.17v-1.7c.07.1.16.2.25.3.5.51 1.1.92 1.8 1.22Zm3.25-2.95c-.52.32-1.11.48-1.78.48a3.5 3.5 0 0 1-3.13-1.85 3.96 3.96 0 0 1-.47-1.95c-.01-.73.14-1.38.46-1.96A3.5 3.5 0 0 1 85 10.23c.67-.01 1.26.14 1.78.46.53.31.93.76 1.21 1.34.29.57.43 1.23.43 1.98 0 .74-.14 1.4-.43 1.97a3.19 3.19 0 0 1-1.2 1.35Z"
      clip-rule="evenodd"
    />
    <path
      fill="#080808"
      d="M41.47 3.34h3.63l3.25 11.86L51.8 3.34h3.02l3.75 11.62 3.12-11.62H65l-4.9 17.12h-3.13l-3.8-11.35-3.5 11.35h-3.16L41.47 3.34Z"
    />
    <path
      fill="#080808"
      fill-rule="evenodd"
      d="M70.37 20.76c-1.26.01-2.4-.27-3.42-.83-1-.58-1.8-1.37-2.38-2.39a6.95 6.95 0 0 1-.86-3.48c0-1.26.3-2.4.88-3.43a6.35 6.35 0 0 1 2.4-2.4 6.7 6.7 0 0 1 3.37-.85c1.4 0 2.62.3 3.66.93a5.75 5.75 0 0 1 2.36 2.64c.53 1.13.72 2.43.57 3.9H67c.03.58.17 1.1.44 1.59.3.52.7.94 1.23 1.23.53.3 1.12.44 1.77.44.5 0 .96-.1 1.38-.25.43-.17.79-.4 1.08-.69.3-.29.52-.61.64-.98h3.33c-.2.9-.6 1.69-1.2 2.39a6.19 6.19 0 0 1-2.29 1.61c-.91.4-1.91.58-3 .57Zm-2.93-9.11c-.19.32-.31.67-.39 1.04h6.6a2.96 2.96 0 0 0-1.57-2.35 3.41 3.41 0 0 0-1.63-.38c-.64 0-1.23.15-1.75.44-.53.3-.95.71-1.26 1.25Z"
      clip-rule="evenodd"
    />
    <path
      fill="#080808"
      d="M94.06 7.64c0-1.03.24-1.96.71-2.76a4.88 4.88 0 0 1 2-1.9c.85-.46 1.86-.7 3-.7V5.1c-.53 0-.99.12-1.37.33-.37.21-.66.52-.86.92-.19.37-.29.8-.3 1.3h2.46v2.68h-2.46v10.13h-3.18V10.33h-2.04V7.64h2.04Z"
    />
    <path
      fill="#080808"
      fill-rule="evenodd"
      d="M112.28 20.74c-1.3 0-2.46-.28-3.48-.85a6.3 6.3 0 0 1-2.4-2.37 6.9 6.9 0 0 1-.86-3.46c0-1.29.29-2.45.86-3.46a6.17 6.17 0 0 1 2.4-2.39 7.07 7.07 0 0 1 3.48-.84c1.3 0 2.46.28 3.48.84a6.06 6.06 0 0 1 2.41 2.38c.58 1.01.87 2.17.88 3.47a7 7 0 0 1-.88 3.46c-.56 1-1.36 1.8-2.4 2.37-1.02.57-2.2.85-3.5.85Zm0-2.92a3.2 3.2 0 0 0 3.04-1.8c.28-.56.42-1.22.42-1.96s-.14-1.4-.43-1.97a3.1 3.1 0 0 0-1.22-1.33 3.44 3.44 0 0 0-1.81-.48c-.68 0-1.28.16-1.8.48-.53.31-.93.75-1.22 1.33a4.26 4.26 0 0 0-.42 1.97c0 .74.15 1.4.44 1.97.29.57.7 1 1.2 1.33.52.3 1.12.46 1.8.46Z"
      clip-rule="evenodd"
    />
    <path
      fill="#080808"
      d="M122.48 7.64h-3.54l3.83 12.82h3.09l2.52-8.18 2.71 8.18h3.05l3.84-12.82h-3.2l-2.18 7.98-2.4-7.98h-3.1l-2.39 8.16-2.23-8.16Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'variables'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    fill="none"
    viewBox="0 0 17 16"
  >
    <path
      :stroke="color ?? '#171717'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width=".867"
      d="m10.55 2.667 4.13 2.36c.195.111.293.167.364.246.063.07.11.151.14.24.033.101.033.214.033.44v4.095c0 .225 0 .338-.033.439a.666.666 0 0 1-.14.24c-.071.079-.169.135-.365.247l-4.129 2.36M6.55 8h.004m-4.67-2.048v4.096c0 .225 0 .338.032.439.03.089.077.17.14.24.071.079.17.135.365.247l3.6 2.057c.193.11.29.165.392.187.09.019.184.019.275 0 .102-.022.199-.077.391-.187l3.6-2.057c.196-.112.294-.168.365-.247a.666.666 0 0 0 .14-.24c.033-.101.033-.214.033-.44V5.953c0-.225 0-.338-.033-.439a.667.667 0 0 0-.14-.24c-.071-.079-.169-.135-.365-.247L7.08 2.97c-.192-.11-.289-.165-.391-.187a.667.667 0 0 0-.275 0c-.103.022-.2.077-.392.187l-3.6 2.057c-.196.112-.294.168-.365.247a.667.667 0 0 0-.14.24c-.032.101-.032.214-.032.44Zm4.25 1.631v0a.59.59 0 0 0 0 .834v0c.23.23.603.23.833 0v0a.59.59 0 0 0 0-.834v0a.59.59 0 0 0-.833 0Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'layers'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    fill="none"
    viewBox="0 0 17 16"
  >
    <path
      :stroke="color ?? '#171717'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width=".867"
      d="M11.899 8.906c1.645-.64 2.467-.96 2.698-1.412.2-.392.194-.857-.016-1.244-.243-.446-1.073-.744-2.735-1.34L6.14 2.86c-1.359-.488-2.039-.732-2.483-.578-.386.134-.69.438-.823.824-.154.444.09 1.124.578 2.483l2.048 5.706c.596 1.661.894 2.492 1.34 2.735.387.21.852.216 1.244.016.452-.231.772-1.054 1.412-2.699l.344-.883c.125-.323.188-.484.284-.62.086-.12.191-.225.312-.31.135-.097.296-.16.619-.285l.884-.344Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'layers-large'"
    xmlns="http://www.w3.org/2000/svg"
    width="65"
    height="64"
    fill="none"
    viewBox="0 0 65 64"
  >
    <path
      stroke="#000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-opacity=".6"
      stroke-width="3.467"
      d="M45.894 35.623c6.58-2.559 9.87-3.838 10.794-5.647A5.333 5.333 0 0 0 56.623 25c-.971-1.784-4.294-2.977-10.94-5.362L22.86 11.445c-5.437-1.951-8.155-2.927-9.932-2.312a5.334 5.334 0 0 0-3.295 3.295c-.615 1.777.36 4.495 2.313 9.932l8.193 22.824c2.385 6.645 3.578 9.968 5.362 10.939a5.333 5.333 0 0 0 4.974.065c1.81-.924 3.09-4.214 5.648-10.794l1.375-3.536c.501-1.289.752-1.933 1.14-2.476a5.334 5.334 0 0 1 1.244-1.245c.543-.387 1.187-.638 2.476-1.139l3.536-1.375Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'layers-selected'"
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    fill="none"
    viewBox="0 0 64 64"
  >
    <path
      fill="#000"
      fill-opacity=".8"
      fill-rule="evenodd"
      d="M45 32c0 7.18-5.82 13-13 13s-13-5.82-13-13 5.82-13 13-13 13 5.82 13 13Zm1 0c0 7.732-6.268 14-14 14s-14-6.268-14-14 6.268-14 14-14 14 6.268 14 14Zm-15.146 4.854 8.5-8.5-.707-.707-8.147 8.146-4.146-4.146-.707.707 4.5 4.5a.5.5 0 0 0 .707 0Z"
      clip-rule="evenodd"
    />
    <path
      fill="#000"
      fill-opacity=".8"
      fill-rule="evenodd"
      d="M32 61c16.016 0 29-12.984 29-29S48.016 3 32 3 3 15.984 3 32s12.984 29 29 29Zm0 1c16.569 0 30-13.431 30-30C62 15.431 48.569 2 32 2 15.431 2 2 15.431 2 32c0 16.569 13.431 30 30 30Z"
      clip-rule="evenodd"
      opacity=".2"
    />
    <path
      fill="#000"
      fill-opacity=".8"
      fill-rule="evenodd"
      d="M32 53c11.598 0 21-9.402 21-21s-9.402-21-21-21-21 9.402-21 21 9.402 21 21 21Zm0 1c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22Z"
      clip-rule="evenodd"
      opacity=".4"
    />
  </svg>
  <svg
    v-else-if="icon === 'styles'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    fill="none"
    viewBox="0 0 17 16"
  >
    <path
      :stroke="color ?? '#171717'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width=".867"
      d="M9.883 11.667a2.333 2.333 0 1 0 4.667 0 2.333 2.333 0 0 0-4.667 0ZM2.55 4.333a2.333 2.333 0 1 0 4.667 0 2.333 2.333 0 0 0-4.667 0ZM9.883 4.333a2.333 2.333 0 1 0 4.667 0 2.333 2.333 0 0 0-4.667 0ZM2.55 11.667a2.333 2.333 0 1 0 4.667 0 2.333 2.333 0 0 0-4.667 0Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'styles-large'"
    xmlns="http://www.w3.org/2000/svg"
    width="65"
    height="64"
    fill="none"
    viewBox="0 0 65 64"
  >
    <path
      stroke="#171717"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-opacity=".6"
      stroke-width="3.467"
      d="M37.833 46.667a9.333 9.333 0 1 0 18.667 0 9.333 9.333 0 0 0-18.667 0ZM8.5 17.333a9.333 9.333 0 1 0 18.667 0 9.333 9.333 0 0 0-18.667 0ZM37.833 17.333a9.333 9.333 0 1 0 18.667 0 9.333 9.333 0 0 0-18.667 0ZM8.5 46.667a9.333 9.333 0 1 0 18.667 0 9.333 9.333 0 0 0-18.667 0Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'images'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    fill="none"
    viewBox="0 0 17 16"
  >
    <path
      :fill="color ?? '#171717'"
      fill-rule="evenodd"
      d="M12.55 3h-8a1 1 0 0 0-1 1v5.668l2.521-2.522a.5.5 0 0 1 .708 0l5.85 5.85A1 1 0 0 0 13.55 12V4a1 1 0 0 0-1-1Zm-10 7.875V12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v6.875Zm2 2.125h6.668L6.425 8.207 3.55 11.082V12a1 1 0 0 0 1 1Zm7-7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm1 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'settings-dark'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
  >
    <g clip-path="url(#a)">
      <path
        fill="#000"
        fill-opacity=".8"
        fill-rule="evenodd"
        d="M12 16.05V9h1v7.05a2.5 2.5 0 0 1 0 4.9V23h-1v-2.05a2.5 2.5 0 0 1 0-4.9Zm2 2.45a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5 4.5h1v-7.05a2.5 2.5 0 0 0 0-4.9V9h-1v2.05a2.5 2.5 0 0 0 0 4.9V23Zm2-9.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
        clip-rule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M10 9h12v14H10z" /></clipPath>
    </defs>
  </svg>
  <svg
    v-else-if="icon === 'webflow-icon'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    fill="none"
    viewBox="0 0 16 17"
  >
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="m15.333 4.5-4.042 8H7.495l1.692-3.316H9.11C7.715 11.02 5.633 12.226 2.666 12.5V9.23s1.898-.113 3.014-1.3H2.667V4.5h3.386v2.82h.076L7.513 4.5h2.562v2.803h.076L11.587 4.5h3.746Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'layouts'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    fill="none"
    viewBox="0 0 16 17"
  >
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M3 2.5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-10a1 1 0 0 0-1-1H3Zm5 1h5v3H8v-3Zm-1 0H3v10h4v-10Zm1 10h5v-6H8v6Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'settings'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    fill="none"
    viewBox="0 0 16 17"
  >
    <path
      fill="#fff"
      d="M4 2.5v7H2v1h5v-1H5v-7H4ZM11 14.5v-7h1v7h-1ZM4 14.5v-3h1v3H4ZM11 5.5v-3h1v3h2v1H9v-1h2Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'help'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    fill="none"
    viewBox="0 0 16 17"
  >
    <path
      fill="#fff"
      d="M7.5 4.5A1.5 1.5 0 0 0 6 6v.5h1V6a.5.5 0 0 1 .5-.5h1.826a.5.5 0 0 1 .38.825L8.36 7.894A1.5 1.5 0 0 0 8 8.87v.63h1v-.63a.5.5 0 0 1 .12-.325l1.345-1.569c.834-.973.142-2.476-1.14-2.476H7.5ZM8.5 11.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
    />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M8.5 2.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 8a6.5 6.5 0 1 1 13 0A6.5 6.5 0 0 1 2 8Z"
      clip-rule="evenodd"
      opacity=".4"
    />
  </svg>
  <svg
    v-else-if="icon === 'log-out'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    fill="none"
    viewBox="0 0 16 17"
  >
    <path fill="#fff" d="M7 3.5H3v9h4v1H3a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h4v1Z" />
    <path
      fill="#fff"
      d="M10.146 10.646 12.293 8.5H5.5v-1h6.793l-2.147-2.146.708-.708L14.207 8l-3.353 3.354-.708-.708Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'component'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <path
      :fill="color ?? '#9747FF'"
      d="m10.063 12.15-1.344-1.343c-.198-.198-.297-.297-.41-.334a.5.5 0 0 0-.31 0c-.114.037-.213.136-.411.334L6.245 12.15c-.198.198-.298.297-.335.412a.5.5 0 0 0 0 .309c.037.114.137.213.335.41l1.343 1.344c.198.198.297.297.411.335a.5.5 0 0 0 .31 0c.113-.038.212-.137.41-.335l1.344-1.343c.198-.198.297-.297.334-.411a.5.5 0 0 0 0-.31c-.037-.114-.136-.213-.334-.41ZM10.063 4.372 8.719 3.03c-.198-.198-.297-.297-.41-.334a.5.5 0 0 0-.31 0c-.114.037-.213.136-.411.334L6.245 4.372c-.198.198-.298.297-.335.412a.5.5 0 0 0 0 .309c.037.114.137.213.335.41l1.343 1.344c.198.198.297.297.411.334a.5.5 0 0 0 .31 0c.113-.037.212-.136.41-.334l1.344-1.343c.198-.198.297-.297.334-.411a.5.5 0 0 0 0-.31c-.037-.114-.136-.213-.334-.41ZM13.952 8.261l-1.344-1.343c-.198-.198-.297-.297-.41-.334a.5.5 0 0 0-.31 0c-.114.037-.213.136-.41.334l-1.344 1.343c-.198.198-.297.298-.335.412a.5.5 0 0 0 0 .309c.038.114.137.213.335.41l1.343 1.344c.198.198.297.297.411.334a.5.5 0 0 0 .31 0c.113-.037.212-.136.41-.334l1.344-1.343c.198-.198.297-.297.334-.411a.5.5 0 0 0 0-.31c-.037-.114-.136-.213-.334-.41ZM6.174 8.261 4.83 6.918c-.198-.198-.297-.297-.41-.334a.5.5 0 0 0-.31 0c-.114.037-.213.136-.411.334L2.355 8.261c-.198.198-.297.298-.334.412a.5.5 0 0 0 0 .309c.037.114.136.213.334.41L3.7 10.737c.198.198.297.297.411.334a.5.5 0 0 0 .31 0c.113-.037.212-.136.41-.334l1.344-1.343c.198-.198.297-.297.334-.411a.5.5 0 0 0 0-.31c-.037-.114-.136-.213-.334-.41Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'instance'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <path
      :stroke="color ?? '#9747FF'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width=".867"
      d="M6.276 3.97c.634-.633.95-.95 1.316-1.068a1.6 1.6 0 0 1 .99 0c.364.118.681.435 1.315 1.069l2.98 2.979c.633.634.95.95 1.068 1.316a1.6 1.6 0 0 1 0 .989c-.118.365-.435.682-1.069 1.315l-2.98 2.98c-.633.633-.95.95-1.315 1.069a1.6 1.6 0 0 1-.989 0c-.365-.119-.682-.436-1.316-1.07L3.297 10.57c-.633-.633-.95-.95-1.069-1.315a1.6 1.6 0 0 1 0-.99c.119-.365.436-.681 1.07-1.315l2.978-2.98Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'frame'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <path
      stroke="#171717"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width=".867"
      d="M2.82 6.16h10.667M2.82 11.494h10.667m-8-8.667v12m5.333-12v12"
    />
  </svg>
  <svg
    v-else-if="icon === 'text'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <path
      stroke="#171717"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width=".867"
      d="M2.82 5.494c0-.621 0-.932.102-1.177.135-.327.395-.586.721-.722.245-.101.556-.101 1.177-.101h6.667c.621 0 .932 0 1.177.101.327.136.586.395.722.722.101.245.101.556.101 1.177M6.154 14.16h4m-2-10.666V14.16"
    />
  </svg>
  <svg
    v-else-if="icon === 'image'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <path
      fill="#000"
      fill-rule="evenodd"
      d="M12.154 3.827h-8a1 1 0 0 0-1 1v5.668l2.52-2.522a.5.5 0 0 1 .709 0l5.85 5.85a1 1 0 0 0 .92-.996v-8a1 1 0 0 0-1-1Zm-10 7.875v1.125a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v6.875Zm2 2.125h6.668L6.029 9.034 3.154 11.91v.918a1 1 0 0 0 1 1Zm7-7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm1 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'horizontal-start'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <rect width="2" height="8" x="3.154" y="3.827" fill="#000" rx="1" />
    <rect width="2" height="10" x="7.154" y="3.827" fill="#000" rx="1" />
    <rect width="2" height="6" x="11.154" y="3.827" fill="#000" rx="1" />
  </svg>
  <svg
    v-else-if="icon === 'horizontal-center'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <rect width="2" height="8" x="3.154" y="4.827" fill="#000" rx="1" />
    <rect width="2" height="10" x="7.154" y="3.827" fill="#000" rx="1" />
    <rect width="2" height="6" x="11.154" y="5.827" fill="#000" rx="1" />
  </svg>
  <svg
    v-else-if="icon === 'horizontal-end'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <rect width="2" height="6" x="3.154" y="3.827" fill="#000" rx="1" />
    <rect width="2" height="10" x="7.154" y="3.827" fill="#000" rx="1" />
    <rect width="2" height="8" x="11.154" y="3.827" fill="#000" rx="1" />
  </svg>
  <svg
    v-else-if="icon === 'vertical-start'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <path
      fill="#000"
      d="M3.154 4.827a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1ZM3.154 8.827a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1ZM3.154 12.827a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2h-4a1 1 0 0 1-1-1Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'vertical-center'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <rect width="8" height="2" x="4.154" y="3.827" fill="#000" rx="1" />
    <rect width="10" height="2" x="3.154" y="7.827" fill="#000" rx="1" />
    <rect width="6" height="2" x="5.154" y="11.827" fill="#000" rx="1" />
  </svg>
  <svg
    v-else-if="icon === 'vertical-end'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <rect width="8" height="2" x="5.154" y="3.827" fill="#000" rx="1" />
    <rect width="10" height="2" x="3.154" y="7.827" fill="#000" rx="1" />
    <rect width="6" height="2" x="7.154" y="11.827" fill="#000" rx="1" />
  </svg>
  <svg
    v-else-if="icon === 'wrap-start'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <rect width="2" height="4" x="3.154" y="3.827" fill="#000" rx="1" />
    <rect width="2" height="4" x="7.154" y="3.827" fill="#000" rx="1" />
    <rect width="2" height="4" x="11.154" y="3.827" fill="#000" rx="1" />
    <rect width="2" height="4" x="3.154" y="9.827" fill="#000" rx="1" />
    <rect width="2" height="4" x="7.154" y="9.827" fill="#000" rx="1" />
  </svg>
  <svg
    v-else-if="icon === 'wrap-center'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <rect width="2" height="4" x="3.154" y="3.827" fill="#000" rx="1" />
    <rect width="2" height="4" x="7.154" y="3.827" fill="#000" rx="1" />
    <rect width="2" height="4" x="11.154" y="3.827" fill="#000" rx="1" />
    <rect width="2" height="4" x="5.154" y="9.827" fill="#000" rx="1" />
    <rect width="2" height="4" x="9.154" y="9.827" fill="#000" rx="1" />
  </svg>
  <svg
    v-else-if="icon === 'wrap-end'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <rect width="2" height="4" x="3.154" y="3.827" fill="#000" rx="1" />
    <rect width="2" height="4" x="7.154" y="3.827" fill="#000" rx="1" />
    <rect width="2" height="4" x="11.154" y="3.827" fill="#000" rx="1" />
    <rect width="2" height="4" x="7.154" y="9.827" fill="#000" rx="1" />
    <rect width="2" height="4" x="11.154" y="9.827" fill="#000" rx="1" />
  </svg>
  <svg
    v-else-if="icon === 'component-facet'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <path
      fill="#000"
      fill-opacity=".67"
      fill-rule="evenodd"
      d="M8.977 2.72a1 1 0 0 0-.98 0L3.33 5.345a1 1 0 0 0-.51.872v5.22a1 1 0 0 0 .51.872l4.667 2.625a1 1 0 0 0 .98 0l4.667-2.625a1 1 0 0 0 .51-.872v-5.22a1 1 0 0 0-.51-.872L8.977 2.72Zm-.653.582a.333.333 0 0 1 .326 0l4.49 2.525-4.653 2.618-4.653-2.618 4.49-2.525ZM3.487 6.397v5.04c0 .12.065.232.17.29l4.497 2.53V9.022L3.487 6.397Zm5.333 7.86 4.497-2.53c.105-.058.17-.17.17-.29v-5.04L8.82 9.022v5.235Z"
      clip-rule="evenodd"
    />
    <path
      fill="#000"
      fill-opacity=".4"
      d="M8.487 6.944a.5.5 0 0 1-.757.429L5.868 6.256a.5.5 0 0 1 0-.858L7.73 4.282a.5.5 0 0 1 .757.428v2.234ZM6.772 9.923a.5.5 0 0 0 0-.858L4.911 7.948a.5.5 0 0 0-.757.429v2.234a.5.5 0 0 0 .757.428l1.861-1.116Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'element-facet'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <path
      fill="#000"
      fill-opacity=".67"
      fill-rule="evenodd"
      d="M2.154 3.827a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1v-10Zm11 0h-10v10h10v-10Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'variable-facet'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <path
      fill="#000"
      fill-opacity=".4"
      fill-rule="evenodd"
      d="M3.911 8.827h-.757a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h8c-.769 0-1.47-.289-2-.764v.007l-.12-.12-.003-.003-.12-.12H3.154v-4H4.91l-1-1Z"
      clip-rule="evenodd"
      opacity=".4"
    />
    <path
      fill="#000"
      fill-opacity=".67"
      fill-rule="evenodd"
      d="M11.154 13.827a2 2 0 0 1-2-2v-8h4v8a2 2 0 0 1-2 2Zm-3-10a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v8a3 3 0 0 1-5 2.236v.007L3.375 8.292a1 1 0 0 1 0-1.415L6.204 4.05a1 1 0 0 1 1.414 0l.536.536v-.758Zm0 2.172v5.657L4.082 7.585l2.829-2.829L8.154 6Zm3 6.828a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'image-facet'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <path fill="#000" fill-opacity=".67" d="M6.154 7.827a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
    <path
      fill="#000"
      fill-opacity=".67"
      fill-rule="evenodd"
      d="M2.154 3.827a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1v-10Zm11 0h-10v9.293l4.293-4.293a1 1 0 0 1 1.414 0l4.293 4.293V3.827Zm-5 5.707 4.293 4.293H3.86l4.293-4.293Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'warning'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      :fill="color ?? '#FFC700'"
      fill-rule="evenodd"
      d="m10.043 3.767 6.277 11.298H3.766l6.277-11.298Zm-.627 6.904v-2.51h1.255v2.51H9.416Zm0 1.256v1.255h1.255v-1.255H9.416Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'warning-black'"
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    fill="none"
    viewBox="0 0 21 20"
  >
    <path
      fill="#000"
      fill-opacity=".8"
      fill-rule="evenodd"
      d="M10.5 3.75 16.75 15H4.25L10.5 3.75Zm-.625 6.875v-2.5h1.25v2.5h-1.25Zm0 1.25v1.25h1.25v-1.25h-1.25Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'warning-outline'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      :fill="color ?? '#FFC700'"
      :stroke="color ?? '#FFC700'"
      d="M9 11a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
    />
    <path
      :fill="color ?? '#FFC700'"
      fill-rule="evenodd"
      d="M7.634 2a1 1 0 0 1 1.732 0l6.062 10.5a1 1 0 0 1-.866 1.5H2.438a1 1 0 0 1-.866-1.5L7.634 2Zm.866.5L2.438 13h12.124L8.5 2.5Z"
      clip-rule="evenodd"
      opacity=".4"
    />
    <path :fill="color ?? '#FFC700'" d="M8.003 4.99h.995v4.006h-.995z" />
  </svg>
  <svg
    v-else-if="icon === 'arrow-top-right'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path :fill="color ?? '#fff'" d="M10.293 5H6V4h6v6h-1V5.707l-5.646 5.647-.708-.708L10.293 5Z" />
  </svg>
  <svg
    v-else-if="icon === 'success'"
    xmlns="http://www.w3.org/2000/svg"
    width="65"
    height="64"
    fill="none"
    viewBox="0 0 65 64"
  >
    <path
      fill="#1BC47D"
      fill-rule="evenodd"
      d="M45.5 32c0 7.18-5.82 13-13 13s-13-5.82-13-13 5.82-13 13-13 13 5.82 13 13Zm1 0c0 7.732-6.268 14-14 14s-14-6.268-14-14 6.268-14 14-14 14 6.268 14 14Zm-15.146 4.854 8.5-8.5-.707-.707L31 35.793l-4.146-4.146-.707.707 4.5 4.5a.5.5 0 0 0 .707 0Z"
      clip-rule="evenodd"
    />
    <path
      fill="#1BC47D"
      fill-rule="evenodd"
      d="M32.5 61c16.016 0 29-12.984 29-29S48.516 3 32.5 3s-29 12.984-29 29 12.984 29 29 29Zm0 1c16.569 0 30-13.431 30-30 0-16.569-13.431-30-30-30-16.569 0-30 13.431-30 30 0 16.569 13.431 30 30 30Z"
      clip-rule="evenodd"
      opacity=".2"
    />
    <path
      fill="#1BC47D"
      fill-rule="evenodd"
      d="M32.5 53c11.598 0 21-9.402 21-21s-9.402-21-21-21-21 9.402-21 21 9.402 21 21 21Zm0 1c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22Z"
      clip-rule="evenodd"
      opacity=".4"
    />
  </svg>
  <svg
    v-else-if="icon === 'select-site'"
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="65"
    fill="none"
    viewBox="0 0 64 65"
  >
    <path
      fill="#000"
      fill-opacity=".8"
      fill-rule="evenodd"
      d="m26.112 3.236-1.13 7.106.988.156 1.13-7.106-.988-.156ZM13.169 18.9l-7.13-1.126-.157.988 7.13 1.126.156-.988Zm19.081-4.566 5.84-4.23.588.809-5.839 4.228-.589-.807ZM8.89 31.25l5.839-4.229.589.808-5.84 4.229-.588-.808Zm8.938-19.193-4.243-5.822-.81.587 4.243 5.822.81-.587Z"
      clip-rule="evenodd"
      opacity=".4"
    />
    <path
      fill="#000"
      fill-opacity=".8"
      fill-rule="evenodd"
      d="M23.182 19.204c-.705-.413-1.563.194-1.416.985l6.44 34.776c.157.849 1.29 1.061 1.745.317l5.878-9.608a.985.985 0 0 1 1.644-.053l7.928 11.277c.3.426.892.531 1.323.23l2.772-1.932a.94.94 0 0 0 .234-1.314l-7.927-11.277a.98.98 0 0 1 .612-1.525l11.075-2.215c.858-.172 1.044-1.3.297-1.738L23.182 19.204Zm-2.4 1.168c-.304-1.642 1.47-2.872 2.906-2.03l30.605 17.922c1.546.905 1.146 3.23-.607 3.581l-11.048 2.21 7.91 11.252a1.94 1.94 0 0 1-.48 2.708l-2.771 1.934a1.953 1.953 0 0 1-2.715-.476L36.67 46.216l-5.864 9.587c-.93 1.521-3.257 1.101-3.582-.656l-6.441-34.775Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'typography-icon'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke="#171717"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width=".867"
      d="M2.667 4.667c0-.622 0-.932.101-1.177.135-.327.395-.587.722-.722.245-.101.555-.101 1.177-.101h6.666c.621 0 .932 0 1.177.101.327.135.587.395.722.722.101.245.101.555.101 1.177M6 13.333h4M8 2.667v10.666"
    />
  </svg>
  <svg
    v-else-if="icon === 'hashtag'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fill="#000"
      fill-rule="evenodd"
      d="M6.276 3.002a.488.488 0 0 1 .443.542l-.213 1.913h3.438l.223-2.003a.512.512 0 0 1 .553-.452.488.488 0 0 1 .443.542l-.213 1.913h1.55a.5.5 0 0 1 0 1h-1.66l-.334 3H12.5a.5.5 0 0 1 0 1h-2.105l-.233 2.093a.512.512 0 0 1-.553.452.488.488 0 0 1-.443-.542l.223-2.003H5.95l-.232 2.093a.512.512 0 0 1-.553.452.487.487 0 0 1-.443-.542l.222-2.003H3.5a.5.5 0 0 1 0-1h1.556l.333-3H3.5a.5.5 0 0 1 0-1h2l.223-2.003a.512.512 0 0 1 .553-.452ZM9.5 9.457l.333-3H6.395l-.334 3H9.5Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'chevron-down'"
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="6"
    fill="none"
    viewBox="0 0 6 6"
  >
    <path
      :fill="color ?? '#000'"
      :fill-opacity="color ? '1' : '.3'"
      fill-rule="evenodd"
      d="M2.624 4.614 0 1.614.752.956 3 3.526 5.248.955 6 1.614l-2.624 3-.376.43-.376-.43Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'empty-variables'"
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    fill="none"
    viewBox="0 0 64 64"
  >
    <path
      fill="#000"
      fill-rule="evenodd"
      d="m46.124 18.213-9.25-5.339a9.75 9.75 0 0 0-9.748 0l-9.25 5.34A9.75 9.75 0 0 0 13 26.657v10.681a9.75 9.75 0 0 0 4.875 8.444l9.25 5.34a9.75 9.75 0 0 0 9.75 0l9.25-5.34A9.75 9.75 0 0 0 51 37.339V26.658a9.75 9.75 0 0 0-4.876-8.445Zm-9.75-4.473 9.25 5.34A8.75 8.75 0 0 1 50 26.657v10.681a8.75 8.75 0 0 1-4.375 7.578l-9.25 5.34a8.75 8.75 0 0 1-8.75 0l-9.25-5.34A8.75 8.75 0 0 1 14 37.339V26.658a8.75 8.75 0 0 1 4.376-7.579l9.25-5.339a8.75 8.75 0 0 1 8.748 0Zm-4.249 7.363a.25.25 0 0 0-.25 0l-.77.444-.5-.866.77-.445a1.25 1.25 0 0 1 1.25 0l.77.445-.5.866-.77-.444Zm-2.563 1.334-1.541.89-.5-.866 1.542-.89.5.866Zm6.417.89-1.541-.89.5-.866 1.541.89-.5.866Zm-9.5.89-1.541.89-.5-.866 1.541-.89.5.866Zm12.584.89-1.542-.89.5-.866 1.541.89-.5.866Zm-15.667.89-.771.445a.25.25 0 0 0-.125.216v.89h-1v-.89c0-.446.238-.86.625-1.082l.771-.445.5.866Zm17.979.445-.77-.445.499-.866.77.445c.388.223.626.636.626 1.082v.89h-1v-.89a.25.25 0 0 0-.125-.216ZM22.5 29.329v1.78h-1v-1.78h1Zm19 1.78v-1.78h1v1.78h-1Zm0 3.56v-1.78h1v1.78h-1Zm-19-1.78v1.78h-1v-1.78h1Zm0 3.561v.89c0 .09.048.172.125.217l.77.445-.5.866-.77-.445a1.25 1.25 0 0 1-.625-1.083v-.89h1Zm19 .89v-.89h1v.89c0 .447-.238.86-.625 1.083l-.77.445-.5-.866.77-.445a.25.25 0 0 0 .125-.217Zm-16.563 1.552 1.542.89-.5.866-1.541-.89.5-.866Zm12.584.89 1.541-.89.5.866-1.541.89-.5-.866Zm-9.5.89 1.541.89-.5.866-1.541-.89.5-.866Zm6.416.89 1.542-.89.5.866-1.541.89-.5-.866Zm-3.333.89.771.446a.25.25 0 0 0 .25 0l.77-.446.5.867-.77.445a1.25 1.25 0 0 1-1.25 0l-.77-.446.5-.865ZM32 33a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      clip-rule="evenodd"
      opacity=".4"
    />
    <path
      fill="#000"
      fill-rule="evenodd"
      d="m13.877 11.284 9.25-5.339a17.75 17.75 0 0 1 17.746 0l9.25 5.34A17.75 17.75 0 0 1 59 26.657V37.34a17.75 17.75 0 0 1-8.874 15.372l-9.25 5.341a17.75 17.75 0 0 1-17.752 0l-9.25-5.341A17.75 17.75 0 0 1 5 37.339V26.658a17.75 17.75 0 0 1 8.877-15.374Zm9.75-4.473-9.25 5.34A16.75 16.75 0 0 0 6 26.657V37.34a16.75 16.75 0 0 0 8.374 14.506l9.25 5.341a16.75 16.75 0 0 0 16.752 0l9.25-5.341A16.75 16.75 0 0 0 58 37.339V26.658a16.75 16.75 0 0 0-8.377-14.507l-9.25-5.34a16.75 16.75 0 0 0-16.746 0Z"
      clip-rule="evenodd"
      opacity=".1"
    />
  </svg>
  <svg
    v-else-if="icon === 'times'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fill="#000"
      fill-rule="evenodd"
      d="m8.707 8 3.647-3.646-.707-.708L8 7.293 4.354 3.646l-.708.708L7.293 8l-3.647 3.646.708.708L8 8.707l3.646 3.647.708-.707L8.707 8Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'text-style'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fill="#000"
      fill-rule="evenodd"
      d="M4.126 4h1.748l2.353 8H7.185l-.588-2H3.403l-.589 2H1.773l2.353-8Zm2.176 5L5.126 5h-.252L3.698 9h2.604ZM12.5 7H10V6h2.5A1.5 1.5 0 0 1 14 7.5V12h-1v-.71a2.888 2.888 0 0 1-1.9.71H11a2 2 0 1 1 0-4h2v-.5a.5.5 0 0 0-.5-.5Zm.5 2v.1a1.9 1.9 0 0 1-1.9 1.9H11a1 1 0 1 1 0-2h2Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'error'"
    xmlns="http://www.w3.org/2000/svg"
    width="65"
    height="64"
    fill="none"
    viewBox="0 0 65 64"
  >
    <path
      fill="#F24822"
      fill-rule="evenodd"
      d="M45.5 32c0 7.18-5.82 13-13 13s-13-5.82-13-13 5.82-13 13-13 13 5.82 13 13Zm1 0c0 7.732-6.268 14-14 14s-14-6.268-14-14 6.268-14 14-14 14 6.268 14 14Zm-9.146-4.146L33.207 32l4.147 4.147-.707.707-4.147-4.147-4.146 4.147-.707-.707L31.793 32l-4.146-4.146.707-.707 4.146 4.146 4.147-4.146.707.707Z"
      clip-rule="evenodd"
    />
    <path
      fill="#F24822"
      fill-rule="evenodd"
      d="M32.5 61c16.016 0 29-12.984 29-29S48.516 3 32.5 3s-29 12.984-29 29 12.984 29 29 29Zm0 1c16.569 0 30-13.431 30-30 0-16.569-13.431-30-30-30-16.569 0-30 13.431-30 30 0 16.569 13.431 30 30 30Z"
      clip-rule="evenodd"
      opacity=".2"
    />
    <path
      fill="#F24822"
      fill-rule="evenodd"
      d="M32.5 53c11.598 0 21-9.402 21-21s-9.402-21-21-21-21 9.402-21 21 9.402 21 21 21Zm0 1c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22Z"
      clip-rule="evenodd"
      opacity=".4"
    />
  </svg>
  <svg
    v-else-if="icon === 'open-book'"
    width="18"
    height="13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.373 13h1.258c.28-.32.616-.597.995-.819 1.479-.862 4.005-.909 5.386.109H17.5v-9.2S16.703.84 13.08.84c-1.875 0-2.902.602-3.456 1.184a2.568 2.568 0 0 0-.6.976h-.049a2.567 2.567 0 0 0-.599-.976C7.822 1.442 6.795.84 4.92.84 1.297.84.5 3.09.5 3.09v9.19h1.488c1.382-1.019 3.91-.97 5.388-.105.38.223.717.502.997.825ZM9.5 3.289v8.457c.195-.158.403-.3.622-.428.927-.541 2.115-.796 3.241-.787 1.006.008 2.081.227 2.952.759h.185V3.317a2.416 2.416 0 0 0-.505-.595c-.46-.397-1.33-.882-2.915-.882-1.586 0-2.34.484-2.694.835a1.747 1.747 0 0 0-.353.49 1.087 1.087 0 0 0-.053.131l-.005.017.001-.006.002-.008v-.005l.001-.002V3.29l-.005-.001H9.5Zm-1 0h-.474l-.006.001v.002l.001.002.001.005.002.008.001.006c0 .001 0-.005-.005-.017a1.091 1.091 0 0 0-.053-.131 1.746 1.746 0 0 0-.353-.49C7.26 2.324 6.506 1.84 4.92 1.84c-1.585 0-2.455.485-2.916.882a2.414 2.414 0 0 0-.504.595v7.963h.185c.872-.532 1.948-.752 2.954-.759 1.128-.008 2.316.249 3.243.792.217.127.424.27.618.426V3.29Z"
      :fill="color ?? '#fff'"
    />
  </svg>
  <svg
    v-else-if="icon === 'info'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.59 8.188v.865h1.977v4.088H7.59V14h4.867v-.86H10.56V8.189H7.59Zm1.848-1.525a.58.58 0 0 0 .145.403c.1.107.25.161.451.161.197 0 .346-.054.446-.161.1-.107.15-.242.15-.403a.69.69 0 0 0-.043-.247.465.465 0 0 0-.128-.188.462.462 0 0 0-.178-.107.661.661 0 0 0-.247-.043.704.704 0 0 0-.252.043.51.51 0 0 0-.306.3.76.76 0 0 0-.038.242Z"
      fill="#000"
    />
    <rect x=".5" y=".5" width="19" height="19" rx="9.5" stroke="#000" stroke-opacity=".8" />
  </svg>
  <svg
    v-else-if="icon === 'one'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.64 6v8h-.968V7.016h-.047L7.672 8.312v-.984l2-1.328h.969Z" fill="#000" />
    <rect x=".5" y=".5" width="19" height="19" rx="9.5" stroke="#000" stroke-opacity=".8" />
  </svg>
  <svg
    v-else-if="icon === 'two'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.328 14v-.703l2.64-2.89c.31-.34.566-.634.766-.884.2-.252.35-.49.446-.71.099-.224.148-.459.148-.704 0-.28-.068-.524-.203-.73a1.318 1.318 0 0 0-.547-.477 1.773 1.773 0 0 0-.781-.168c-.307 0-.576.064-.805.192-.226.125-.402.3-.527.527a1.652 1.652 0 0 0-.184.797H7.36c0-.469.108-.88.325-1.234.216-.355.51-.63.882-.829a2.661 2.661 0 0 1 1.262-.296c.469 0 .884.099 1.246.296.362.198.646.465.852.801.206.336.308.71.308 1.121 0 .295-.053.582-.16.864-.104.278-.286.59-.547.933-.257.341-.615.758-1.074 1.25l-1.797 1.922v.063h3.719V14H7.328Z"
      fill="#000"
    />
    <rect x=".5" y=".5" width="19" height="19" rx="9.5" stroke="#000" stroke-opacity=".8" />
  </svg>
  <svg
    v-else-if="icon === 'three'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.531 14.11a3.4 3.4 0 0 1-1.379-.266 2.361 2.361 0 0 1-.957-.739A1.985 1.985 0 0 1 6.812 12h.985c.02.258.11.48.266.668.156.185.36.328.613.43.252.101.532.152.84.152.343 0 .648-.06.914-.18.265-.12.474-.286.625-.5.15-.213.226-.46.226-.742 0-.294-.073-.553-.219-.777a1.448 1.448 0 0 0-.64-.531c-.281-.128-.625-.192-1.031-.192H8.75v-.86h.64c.318 0 .597-.057.837-.171A1.299 1.299 0 0 0 11 8.078c0-.27-.06-.506-.18-.707-.12-.2-.289-.357-.508-.469a1.643 1.643 0 0 0-.765-.168c-.276 0-.537.051-.781.153-.243.099-.44.243-.594.433a1.129 1.129 0 0 0-.25.68h-.938c.016-.42.142-.786.38-1.102.236-.317.546-.565.929-.742a3.004 3.004 0 0 1 1.27-.265c.494 0 .919.1 1.273.3.354.198.626.46.816.786.19.325.286.677.286 1.054 0 .45-.119.835-.356 1.153a1.801 1.801 0 0 1-.957.66v.062c.505.084.9.298 1.184.645.283.344.425.77.425 1.277 0 .435-.118.826-.355 1.172a2.415 2.415 0 0 1-.961.813 3.127 3.127 0 0 1-1.387.296Z"
      fill="#000"
    />
    <rect x=".5" y=".5" width="19" height="19" rx="9.5" stroke="#000" stroke-opacity=".8" />
  </svg>
  <svg
    v-else-if="icon === 'four'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.64 12.36v-.797L10.157 6h.578v1.234h-.39l-2.656 4.204v.062h4.734v.86H6.64ZM10.407 14V6h.922v8h-.922Z"
      fill="#000"
    />
    <rect x=".5" y=".5" width="19" height="19" rx="9.5" stroke="#000" stroke-opacity=".8" />
  </svg>
  <svg
    v-else-if="icon === 'play'"
    width="10"
    height="12"
    viewBox="0 0 10 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="m0 .098.765.478 8 5L9.443 6l-.678.424-8 5-.765.478V.098Zm1 1.804v8.196L7.557 6 1 1.902Z"
      fill="#fff"
    />
  </svg>
  <svg
    v-else-if="icon === 'question-mark'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    fill="none"
    viewBox="0 0 17 16"
  >
    <path
      fill="#000"
      d="M8.188 4a1.5 1.5 0 0 0-1.5 1.5V6h1v-.5a.5.5 0 0 1 .5-.5h1.826a.5.5 0 0 1 .38.825L9.05 7.394a1.5 1.5 0 0 0-.362.976V9h1v-.63a.5.5 0 0 1 .12-.325l1.345-1.569C11.987 5.503 11.296 4 10.014 4H8.188ZM9.188 11.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
    />
    <path
      fill="#000"
      fill-rule="evenodd"
      d="M9.188 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm-6.5 5.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0Z"
      clip-rule="evenodd"
      opacity=".4"
    />
  </svg>
  <svg
    v-else-if="icon === 'size'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
  >
    <path
      :fill="color ?? '#F5F5F5'"
      d="M12 4.7 4.7 12h2.8v1H3V8.5h1v2.8L11.3 4H8.5V3H13v4.5h-1V4.7Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'performance'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    fill="none"
    viewBox="0 0 17 16"
  >
    <path
      :fill="color ?? '#fff'"
      d="M3.555 5.001A7.08 7.08 0 0 1 8.5 3c1.697 0 3.332.603 4.604 1.689l.542-.543.708.708-5.5 5.5a.5.5 0 0 1-.708-.708L12.394 5.4A6.094 6.094 0 0 0 8.5 4a6.08 6.08 0 0 0-4.247 1.717A5.77 5.77 0 0 0 2.5 9.847V11h-1V9.846c0-1.82.74-3.562 2.055-4.845ZM13.803 7.111l.733-.732a6.731 6.731 0 0 1 .964 3.467V11h-1V9.846c0-.961-.243-1.9-.697-2.735Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'number-variable'"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      :fill="color ?? '#171717'"
      fill-rule="evenodd"
      d="M11.498 9.55a.5.5 0 1 0-.995-.1l-.056.55H9.5a.5.5 0 0 0 0 1h.848l-.2 2H9.5a.5.5 0 0 0 0 1h.547l-.045.45a.5.5 0 0 0 .995.1l.056-.55h1.494l-.045.45a.5.5 0 0 0 .995.1l.056-.55h.947a.5.5 0 0 0 0-1h-.848l.2-2h.648a.5.5 0 0 0 0-1h-.547l.045-.45a.5.5 0 1 0-.995-.1l-.056.55h-1.494zM11.153 13l.2-2h1.495l-.2 2z"
      clip-rule="evenodd"
    />
    <path
      :fill="color ?? '#171717'"
      fill-rule="evenodd"
      d="M8 6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM7 8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'length-variable'"
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    fill="none"
    viewBox="2 2 12 12"
  >
    <path
      fill="#000"
      fill-rule="evenodd"
      d="M6.276 3.002a.488.488 0 0 1 .443.542l-.213 1.913h3.438l.223-2.003a.512.512 0 0 1 .553-.452.488.488 0 0 1 .443.542l-.213 1.913h1.55a.5.5 0 0 1 0 1h-1.66l-.334 3H12.5a.5.5 0 0 1 0 1h-2.105l-.233 2.093a.512.512 0 0 1-.553.452.488.488 0 0 1-.443-.542l.223-2.003H5.95l-.232 2.093a.512.512 0 0 1-.553.452.487.487 0 0 1-.443-.542l.222-2.003H3.5a.5.5 0 0 1 0-1h1.556l.333-3H3.5a.5.5 0 0 1 0-1h2l.223-2.003a.512.512 0 0 1 .553-.452ZM9.5 9.457l.333-3H6.395l-.334 3H9.5Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg v-else-if="icon === 'color-variable'" width="20" height="20" fill="none" viewBox="0 0 24 24">
    <path
      :fill="color ?? '#171717'"
      fill-rule="evenodd"
      d="M16.95 7.05a6.97 6.97 0 0 1 2.005 4.15c.2 1.75-1.36 2.8-2.73 2.8H15a1 1 0 0 0-1 1v1.225c0 1.37-1.05 2.93-2.8 2.73A7 7 0 1 1 16.95 7.05m1.01 4.264c.112.97-.759 1.686-1.735 1.686H15a2 2 0 0 0-2 2v1.225c0 .976-.715 1.847-1.686 1.736a6 6 0 1 1 6.647-6.646M13 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3.134 2.5a1 1 0 1 0-1.732-1 1 1 0 0 0 1.732 1m5.634.366a1 1 0 1 1-1-1.732 1 1 0 0 1 1 1.732M8.134 14.5a1 1 0 1 0 1.732-1 1 1 0 0 0-1.732 1"
      clip-rule="evenodd"
    />
  </svg>
  <svg v-else-if="icon === 'color-swatch'" width="12" height="12" fill="none" viewBox="5 5 14 14">
    <path
      :fill="color ?? '#171717'"
      fill-rule="evenodd"
      d="M16.95 7.05a6.97 6.97 0 0 1 2.005 4.15c.2 1.75-1.36 2.8-2.73 2.8H15a1 1 0 0 0-1 1v1.225c0 1.37-1.05 2.93-2.8 2.73A7 7 0 1 1 16.95 7.05m1.01 4.264c.112.97-.759 1.686-1.735 1.686H15a2 2 0 0 0-2 2v1.225c0 .976-.715 1.847-1.686 1.736a6 6 0 1 1 6.647-6.646M13 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3.134 2.5a1 1 0 1 0-1.732-1 1 1 0 0 0 1.732 1m5.634.366a1 1 0 1 1-1-1.732 1 1 0 0 1 1 1.732M8.134 14.5a1 1 0 1 0 1.732-1 1 1 0 0 0-1.732 1"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'typography-variable'"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      :fill="color ?? '#171717'"
      fill-rule="evenodd"
      d="M8 7h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1M6 8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zm3.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0V10h1.5v4H11a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-.5v-4H14v.5a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5z"
      clip-rule="evenodd"
    />
  </svg>
  <svg v-else-if="icon === 'typography'" width="12" height="12" fill="none" viewBox="6 6 12 12">
    <path
      :fill="color ?? '#171717'"
      fill-rule="evenodd"
      d="M8 7h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1M6 8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zm3.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0V10h1.5v4H11a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-.5v-4H14v.5a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5z"
      clip-rule="evenodd"
    />
  </svg>
  <svg v-else-if="icon === 'effect-style'" width="20" height="20" fill="none" viewBox="0 0 24 24">
    <path
      :fill="color ?? '#171717'"
      fill-rule="evenodd"
      d="M17 6H7a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1M7 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z"
      clip-rule="evenodd"
    />
    <path
      :fill="color ?? '#0000004d'"
      fill-rule="evenodd"
      d="M5 17v3a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="icon === 'group'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    fill="none"
    viewBox="0 0 17 16"
  >
    <path
      fill="#000"
      d="M9.55 3h-2v1h2V3Zm2.5 9h.5v-.5h1V13h-1.5v-1Zm-7.5-5v2h-1V7h1Zm8-2.5V4h-.5V3h1.5v1.5h-1Zm0 2.5v2h1V7h-1Zm-8-2.5V4h.5V3h-1.5v1.5h1Zm-1 7h1v.5h.5v1h-1.5v-1.5Zm6 .5h-2v1h2v-1Z"
    />
  </svg>
</template>

<script setup>
defineProps(['icon', 'color']);
</script>
